"use client"

import { WashingMachine } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WashingMachineIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WashingMachineIcon = component(Icon)({ as: WashingMachine })
